import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerNavigation } from '../data/navigation';
import { brand, professionalContact } from '../data/siteContent';
import { pagePadding } from '../utils/styles';
export function Footer() {
  return <footer className="border-t border-graphite bg-night" data-id="element-138" data-mp="36q93j5yqqyrl">
      <div className={`grid gap-12 py-14 md:grid-cols-[1.4fr_1fr_1fr] md:py-16 ${pagePadding}`} data-id="element-139" data-mp="3ufa4y995p9nd">
        <div data-id="element-140" data-mp="38h4x8q3ngkf">
          <Link to="/" aria-label="NICOLE, ir al inicio" className="inline-block rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-4 focus-visible:ring-offset-night" data-id="element-141" data-mp="39904ifsbca6">
            <Logo className="text-xl" data-id="element-142" data-mp="3qc3yp1m1nigw" />
          </Link>
          <p className="mt-5 font-display text-lg font-semibold text-white" data-id="element-143" data-mp="29zgli2s8ywn6">«{brand.slogan}».</p>
          {professionalContact.email && <a href={`mailto:${professionalContact.email}`} className="mt-6 inline-flex items-center gap-2 text-sm text-mist transition-colors duration-150 ease-out hover:text-white" data-id="element-144" data-mp="2ez1ja9vokyyb">
              <MailIcon className="h-4 w-4" data-id="element-145" data-mp="3gcjzp1x0gkm6" />
              Contacto profesional: {professionalContact.email}
            </a>}
        </div>

        {footerNavigation.map(group => <nav key={group.heading} aria-label={group.heading} data-id="element-146" data-mp="3q7bz8ba5lhjl">
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-mist" data-id="element-147" data-mp="81yvyfozns2e">{group.heading}</h2>
            <ul className="mt-4 space-y-3" data-id="element-148" data-mp="335s7ezi7fff">
              {group.links.map(link => <li key={link.to} data-id="element-149" data-mp="hrs5lb5klx40">
                  <Link to={link.to} className="rounded-sm text-sm text-white/85 transition-colors duration-150 ease-out hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-150" data-mp="huwiqy10k36t">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>
      <div className={`flex flex-col gap-2 border-t border-graphite py-6 text-xs text-mist sm:flex-row sm:items-center sm:justify-between ${pagePadding}`} data-id="element-151" data-mp="tta24mu25a0e">
        <p data-id="element-152" data-mp="13sirt3hw42gy">© {new Date().getFullYear()} NICOLE. Todos los derechos reservados.</p>
        <p className="flex items-center gap-2" data-id="element-153" data-mp="18l2fitaakdzh">
          <Logo variant="mark" className="h-4 w-4 text-[9px]" data-id="element-154" data-mp="18ltzt7yfupag" />
          Plataforma oficial
        </p>
      </div>
    </footer>;
}